import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';
import { VerifySceneEnum } from '@/shared/verify-credit-controller/types';
import store from '@/store';

import style from './index.module.scss';
import { customSceneUIControls } from '../../const';

@Component({
  name: 'BasicPersonalHeader',
})
export default class BasicPersonalHeader extends Vue {
  @Prop(Boolean) readonly isVerifyStageHeaderUINew!: boolean;

  @Prop(String) readonly verifyScene!: VerifySceneEnum;

  @Prop(Boolean) readonly ocrAfterLoan!: boolean;

  @Prop(Boolean) readonly isLoanProcess!: boolean;

  private get singleHeaderSecurity() {
    return customSceneUIControls.getIsSingleHeaderSecurity(this.verifyScene);
  }

  // 最高额度数值: 20万 or 30万
  private get quotaAmount() {
    return store.state.base.hitMaxQuotaExperiment ? '30' : '20';
  }

  private renderHeaderTitle() {
    /**
     * 注意headerText区域: 因为文案使用的是 FZZhengHeiS-DB-GB 压缩精简后的(剔除未使用的字符)字体
     * 所以，若文案的字符集有变化，需要在 tools/font-spider/test-pages/FZZhengHeiS-DB-GB.html 进行字体包更新
     */
    return this.isVerifyStageHeaderUINew
      ? (
        <div class={style.headerTip}>
          {this.ocrAfterLoan
            ? (<p class={style.headerText}>补充信息 <span class={style.highlight}>享最快30秒放款</span></p>)
            : (<p class={style.headerText}>
              {/* eslint-disable-next-line max-len */}
              只差一步 <span class={style.highlight}>解锁额度最高<span class={style.amount}>{this.quotaAmount}</span>万</span>
              <br />
              请补充信息
            </p>)
          }
        </div>
      )
      : (
        <div class={style.headerTip}>
          <p class={style.headerText} >
          补充资料 <span class={style.highlightText}>加速审批</span>
          </p>
          <p class={style.headerIcon} />
        </div>
      );
  }

  private render() {
    return (
      <div class={[style.basicPersonalHeader]}>
        {this.singleHeaderSecurity ? null : this.renderHeaderTitle()}
        {
          this.singleHeaderSecurity
            ? (<div class={[style.headerSecurity, style.singleHeaderSecurity]}>
              <span class={style.securityIcon} />
              <span>哈啰承诺信息安全加密，</span>
              <span class={style.securityText}>严格保障你的信息安全</span>
            </div>)
            : (
              <div class={style.headerSecurity}>
                <span class={style.securityIcon} />
                <span class={style.securityText}>哈啰承诺信息安全加密，严格保障你的信息安全</span>
              </div>
            )
        }
      </div>
    );
  }
}
